bucket_list_items = function() {

  var $edit_links = $(".bucket-list .bucket-list-edit-links")

  $edit_links.on("click", ".edit-link", function() {
    bucketListItems.toggleEditMode();
    return false;
  })

  $(".bucket-list-items").on("click", "a.remove-link", function() {
    bucketListItems.remove(this)
  })

  $mapItemsData = $("#map_items_data")
  if($mapItemsData.length > 0) {
    $mapItemsData.val(bucketList.items)
    $(".map-button").on("click", "a[data-map-items-button]", function() {
      $("form.map_items").submit()
      return false;
    })
  }

  $saveAlert = $(".save-alert");
  if( bucketList.count > 0 && $saveAlert.length > 0) {
    $saveAlert.show()
  }
}

bucket_list = function() {

  var $button = bucketListButton.button

  $button.on("click", "a.add", function() {
    bucketListButton.save()
    bucketListButton.render()
    return false;
  })

  $button.on("click", "a.remove", function() {
    bucketListButton.remove()
    bucketListButton.render()
    return false;
  })

  bucketListButton.render()
}

$(document).on('bucket-list:ready', bucket_list);
$(document).on('bucket-list-items:ready', bucket_list_items);

// Bucket List Items

var bucketListItems = (function() {
  var $overlay, $removeLink;

  var items = {
    get items() {
      return $(".bucket-list-items a")
    },

    toggleEditMode: function() {
      if($(".card-container .overlay").length > 0) {
        this.exitEditMode();
      } else {
        this.enterEditMode();
      }
    },

    exitEditMode: function() {
      $(".bucket-list-items .overlay").remove();
      $("a.edit-link").html("Edit List")
      $(".bucket-list-items .remove-link").remove();
    },

    enterEditMode: function() {
      $("a.edit-link").html("Done Editing")
      $.each(this.items, function() {
        $(".card-container", this).prepend($overlay.clone())
        $(".card", this).prepend($removeLink.clone())
      })
    },

    render: function() {
      $.post( "/bucket_list_items", {data: bucketList.items}, function( data ) {
        $(".bucket-list-items").html(data)
      });
    },

    remove: function(item) {
      $item = $(item)
      slug = $item.next().find("[data-bucket-slug]").data("bucket-slug")
      bucketList.removeBySlug(slug)
      if (typeof bucketNav !== 'undefined') {
        bucketNav.update();
      }
      $item.parents("a").remove()
    },
    loggedInRender: function(){
      if(bucketList.count > 0) {
        this.saveToDb();
      }
      else{
        this.render();
      }
    },

    saveToDb: function() {
      bucketList.store(bucketList.items, this.render);
    },
  }

  $overlay = $("<div class='overlay'></div>")
  $removeLink = $("<a href='#' class='remove-link'>X</div>")

  return items;
}());



// Bucket List Button
var bucketListButton = {
  get button() {
    return $(".bucket-list-button")
  },

  get isAdded() {
    result =  $.inArray(this.currentItem, bucketList.items)
    if(this.button.data("added") == true || result > -1) {
      return true
    } else {
      return false
    }
  },

  render: function() {
    if(this.isAdded) {
      this.renderAdded()
    } else {
      this.renderAdd()
    }
  },

  renderAdded: function() {
    this.button.html("<i class='fa fa-heart' aria-hidden='true'></i> Added To Bucket List <a class='remove' href='#'>Remove</a>")
  },

  renderAdd: function() {
    this.button.html("<a class='add' href='#'><i class='fa fa-heart-o' aria-hidden='true'></i> Add To Bucket List</a>")
  },

  get currentItem() {
    return this.button.data("id") + "-" + this.button.data("type")
  },

  remove: function() {
    this.button.data("added", false)
    bucketList.removeBySlug(this.currentItem)
    bucketNav.update()
  },

  save: function(){
    items = bucketList.items
    items.push(this.currentItem)
    bucketList.store(items)
    this.button.data("added", true)
    bucketNav.update()
  },

}


//Bucket Nav

window.bucketNav = {
  update: function() {
    this.updateCount(bucketList.count)
  },
  updateMobile: function(){
    this.updateCountMobile(bucketList.count)
  },
  updateCountMobile: function(count){
    mobileEl = $("li.bucket-list-count-mobile")
    mobileEl.find("span").html(count)
    if(count > 0 && mobileEl.not(":visible")) {
      mobileEl.addClass("show-count")
    }
    if (count == 0 && mobileEl.is(":visible"))  {
      mobileEl.removeClass("show-count")
    }
  },
  updateCount: function(count){
    nav = $("ul.user-nav")
    el = nav.find("li.bucket-list-count")
    el.find("span").html(count)
    if(count > 0 && el.not(":visible")) {
      el.addClass("show-count")
    }
    if (count == 0 && el.is(":visible"))  {
      el.removeClass("show-count")
    }
  },
}


// Bucket List

var bucketList = {
  get items() {
    if(!localStorage["bucketListItems"]) {
      this.store([])
    }
    return $.parseJSON(localStorage["bucketListItems"]);
  },

  get count() {
    return this.items.length
  },

  get userSignedIn() {
    return $("span.user-signed-in").length > 0
  },

  removeBySlug: function(slug) {
    if(this.userSignedIn) {
      $.post( "/remove_bucket_list_item", {data: [ slug ]}, function( data ) {
        bucketNav.updateCount(data.count)
      });
    } else {
      items = this.items
      index = items.indexOf(slug)
      items.splice(index, 1)
      this.store(items)
    }
  },

  clearAll: function() {
    this.store([])
  },

  store: function(items, renderCallback) {
    if(this.userSignedIn && items.length > 0) {
      var $this = this
      $.post( "/save_bucket_list_items", {data: items}, function( data ) {
        $this.clearAll();
        bucketNav.updateCount(data.count)
        if(renderCallback !== undefined){
          renderCallback();
        }
      });
    } else {
      localStorage["bucketListItems"] = JSON.stringify(items)
    }
  },
}
